const DECIMAL_TEXT_RE = /^[+-]?(?:\d+(?:\.\d+)?|\.\d+)$/

function toNumber(value) {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : 0
  }
  if (value === null || value === undefined) {
    return 0
  }
  const text = String(value).trim()
  if (text === '') {
    return 0
  }
  if (!DECIMAL_TEXT_RE.test(text)) {
    return 0
  }
  const num = Number(text)
  return Number.isFinite(num) ? num : 0
}

function formatAsset24hRate(value) {
  const num = toNumber(value)
  const prefix = num > 0 ? '+' : ''
  return `${prefix}${num.toFixed(2)}%`
}

function asset24hRateClass(value) {
  const num = toNumber(value)
  if (num > 0) return 'green'
  if (num < 0) return 'red'
  return ''
}

module.exports = {
  formatAsset24hRate,
  asset24hRateClass
}
